import React from 'react';
import Icon from '../../../components/AppIcon';

const LiveStatistics = ({ events }) => {
  // Calculate statistics from events
  const stats = {
    currentOccupancy: 47,
    occupancyPercentage: 78,
    activeClasses: 3,
    todayRevenue: 1247.50,
    recentCheckIns: events?.filter(e => e?.type === 'check-in')?.length || 0,
    pendingAlerts: events?.filter(e => e?.priority === 'high')?.length || 0
  };

  const statCards = [
    {
      title: 'Current Occupancy',
      value: stats?.currentOccupancy,
      subtitle: `${stats?.occupancyPercentage}% capacity`,
      icon: 'Users',
      color: stats?.occupancyPercentage > 80 ? 'warning' : 'success',
      trend: '+5 in last hour'
    },
    {
      title: 'Active Classes',
      value: stats?.activeClasses,
      subtitle: '2 starting soon',
      icon: 'Calendar',
      color: 'primary',
      trend: '8 scheduled today'
    },
    {
      title: "Today\'s Revenue",
      value: `$${stats?.todayRevenue?.toFixed(2)}`,
      subtitle: '+12% vs yesterday',
      icon: 'DollarSign',
      color: 'success',
      trend: '23 transactions'
    },
    {
      title: 'Pending Alerts',
      value: stats?.pendingAlerts,
      subtitle: stats?.pendingAlerts > 0 ? 'Require attention' : 'All clear',
      icon: 'AlertCircle',
      color: stats?.pendingAlerts > 0 ? 'error' : 'success',
      trend: stats?.pendingAlerts > 0 ? 'Action needed' : 'No issues'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      success: 'bg-success/10 text-success',
      error: 'bg-error/10 text-error',
      warning: 'bg-warning/10 text-warning',
      primary: 'bg-primary/10 text-primary'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="card hover:shadow-lg transition-all duration-250">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
          </div>
          
          <div>
            <p className="text-sm text-muted-foreground mb-1">{stat?.title}</p>
            <p className="text-3xl font-bold text-foreground mb-2">{stat?.value}</p>
            <p className="text-xs text-muted-foreground mb-2">{stat?.subtitle}</p>
            <div className="flex items-center gap-1 text-xs text-muted-foreground pt-2 border-t border-border">
              <Icon name="TrendingUp" size={12} />
              <span>{stat?.trend}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LiveStatistics;